export default "__VITE_ASSET__pl6viGrZ__"